import React from 'react'
import CreateRoles from '../../../components/organisms/admin/roles/CreateRoles'

type Props = {}

const CreateRolesPage = (props: Props) => {
  return (
    <CreateRoles />
  )
}

export default CreateRolesPage